/**************************************************************************
 *
 * 2019-6-23
 * ryj
 * do nothing.
 *
 *
 ***************************************************************************/
/**
 * Created by yz on 2017/3/27.
 */
{
    angular
        .module("dataModule")
        .factory("request.login", login);
    login.$inject = ['$q','$state',"requestHandler","utils.constant",
    '$timeout','md5','utils.platform'];
    function login($q,$state,requestHandler,constant,
        $timeout,md5,platform) {
        let collect={
            'login':login,
            'getUserId':getUserId,
            'getUserInfoById':getUserInfoById,
            'logout':logout,

            'getOpenId':getOpenId,
            'loginWithOpenId':loginWithOpenId,
        }
        return collect;

        function login(userName,password,openId){

            let def=$q.defer();
            let params=[{
                'userid':encodeURIComponent(userName),
                'pwd':md5.createHash(encodeURIComponent(password))
            }]
            let url=constant.action.login;
            if(openId&&openId!=''){
                params[0].wxopenid=openId;
                url=constant.action.wechatLogin;
            }
            // let params='userid='+userName+'&pwd='+password;
            let str='userinfo='+JSON.stringify(params);
            //console.log(str);
            requestHandler.simpleRequest(url,str
                // ,function(response){
                //     let def=$q.defer();
                //     $timeout(function(){
                //         console.log('resolve');
                //         def.resolve(response);
                //     },3000);
                //     return def.promise;
                // }
                )
            .then(function(respone){
                    //console.log(respone.data);
                    let result=respone.data[0].result;
                    //console.log(result);
                    def.resolve(respone.data);
                    /*if(result==1){
                        def.resolve(respone.data);
                    }else if(result==0){
                        def.reject(respone.data);
                    }else if(result==2){
                        def.reject(respone.data);
                    }else{
                        def.reject(respone.data);
                    }*/
                });
            return def.promise;
        }
        
        function getUserId(){
            return requestHandler.simpleRequest(constant.action.getUserId,'')
            .then(function(respone){
                    // console.log(respone.data);

                    return respone.data[0];
                });
        }

        function getUserInfoById(userId){
            let params=[{
                'userid':encodeURIComponent(userId)
            }];
            let paramsStr='userinfo='+JSON.stringify(params);

            return requestHandler.simpleRequest(constant.action.getUserInfoById,paramsStr,
                function(respone){
                    //console.log('通过用户ID访问得到用户信息返回来的结果',respone);   //这是完整的结果；
                    // console.log(respone.data);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){
                        let info=respone.data[0].users.rows[0];
                        data.userInfo={
                            'userId':info.userid,
                            'userName':info.username,
                            'phone':info.phone,
                            'groupname':info.groupname,
                            'gradename': info.gradename,
                            'areaname': info.areaname
                        };
                    }
                    
                    return data;
                });
        }

        function logout(){
            let url=constant.action.logout;
            if(platform.isWechat()){
                url=constant.action.wechatLogout;
            }

            return requestHandler.simpleRequest(url,'')
            .then(function(respone){
                    $state.go('login');
                    return respone.data[0];
                });
        }

        function getOpenId(code){
            // return requestHandler.simpleRequest(constant.action.wechatOpenId,'')
            // .then(function(respone){
            //         console.log(respone);
            //         return respone.data[0];
            //     },function(respone){
            //         console.log(respone);
            //     });

            //return requestHandler.sendRequest('GET',constant.config.sitePath+constant.action.wechatOpenIdViaCode+'?code='+code+'&state=TEST','')
            return requestHandler.sendRequest('GET',constant.action.wechatOpenIdViaCode+'?code='+code+'&state=TEST','')
            .then(function(respone){
                   // console.log(respone);
                    return respone.data[0];
                },function(respone){
                    //console.log(respone);
                });
        }

        function loginWithOpenId(openId){
            let params=[{
                'wxopenid':openId
            }]
            let str='userinfo='+JSON.stringify(params);
            return requestHandler.simpleRequest(constant.action.wechatLogin,str)
            .then(function(respone){
                    return respone.data[0];
                });
        }
    }

}